import { render, staticRenderFns } from "./kpsrScenario.vue?vue&type=template&id=cc28c992"
import script from "./kpsrScenario.vue?vue&type=script&lang=js"
export * from "./kpsrScenario.vue?vue&type=script&lang=js"
import style0 from "./kpsrScenario.vue?vue&type=style&index=0&id=cc28c992&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc28c992')) {
      api.createRecord('cc28c992', component.options)
    } else {
      api.reload('cc28c992', component.options)
    }
    module.hot.accept("./kpsrScenario.vue?vue&type=template&id=cc28c992", function () {
      api.rerender('cc28c992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/action/kpsrScenario.vue"
export default component.exports